<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        <v-btn text small :to="{ name: 'Remark' }">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          outlined
          class="mx-2"
          @click="downloadLink(proforma)"
        >
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>
        <v-btn color="primary" @click="pay">
          <v-icon left> mdi-send </v-icon>
          Pay KES
          {{ parseFloat(this.amountToPay.replace(/,/g, "")) | currencyFormat }}
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="8" offset="2">
            <v-card-text class="elevation-1 my-1">
              <pdf style="width: 100%" :src="proforma" />
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import FileMixin from "@brainspore/celadon-base/mixin/FileMixin";
import pdf from "vue-pdf";
import { AuthService } from "@/packages/dashboard/modules/auth";
import { helper } from "@/packages/dashboard/utils";
export default {
  name: "RemarkPayments",
  components: { pdf },
  mixins: [FileMixin],
  data: function () {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.params.code) {
        v.$store.dispatch(
          "Remark/getExamRemark",
          helper.encrypt(to.params.code),
        );
        window.document.title = "KISEB::Pay For Remark";
        v.$store.dispatch("Remark/getRemarkProforma", to.params.code);
      }
    });
  },
  computed: {
    remark() {
      return this.$store.getters["Remark/remarkGetter"]("remark");
    },
    proforma() {
      return this.$store.getters["Remark/remarkGetter"]("proforma");
    },
    user() {
      return AuthService.user;
    },
  },
  methods: {
    pay: function () {
      const data = this.remark;
      this.$confirm.show({
        title: "Remark Payment",
        rejectLabel: "Pay Later",
        text: `Application Payment for Remark Record No. ${data.no}`,
        onConfirm: () => {
          let payload = {
            payerID: data.profileID,
            sourceDocumentNo: data.no,
            description: "Remark Payment",
            amount: parseFloat(this.amountToPay.replace(/,/g, "")).toString(),
            accountNo: this.user["phone_number"],
            success_url: `${process.env.VUE_APP_URL}${
              this.$router.resolve({ name: "Remark" }).href
            }`,
            fail_url: window.location.href,
          };

          payload = btoa(JSON.stringify(payload));
          window.open(
            `${process.env.VUE_APP_PAYGATE_CHECKOUT_URL}/?payload=${payload}`,
            "_blank",
          );
        },
        onCancel: () => {
          Event.$emit("ApiInfo", "Payment cancelled");
          this.$router.replace({ name: "Remark" });
          this.$store.dispatch("Remark/getRemarks");
        },
      });
    },
  },
  watch: {
    remark: function (val) {
      if (val) {
        this.$store.dispatch("Dashboard/getStudentAmountToPay", {
          profileNo: val.profileID,
          amount: val.amount,
        });
      }
    },
  },
};
</script>

<style scoped></style>
